export default "__VITE_ASSET__a72ef1b6__"